/*
 * Created: 2019-07-09 09:51:52
 * Author : zc
 * Email : 591074801@qq.com
 * -----
 * Description: order api
 */
import request from '@/utils/request'

/**订单已出库清单 */
export const stock = function (id: string) {
    return request.get(`/api/Order/${id}/stock`, {})
}

/**订单已发货清单 */
export const shippedList = function (id: string) {
    return request.get(`/api/Order/${id}/shippedList`, {})
}

/**订单扣款记录 */
export const accountHistory = function (id: string) {
    return request.get(`/api/Order/${id}/AccountHistory`, {})
}